import cdn from 'config/cdn';

const logosCH = [
  [
    {
      link: `//${cdn}/assets/portals/logo-e-domizil-60.png`,
      alt: 'e-domizil',
    },
    {
      link: `//${cdn}/assets/portals/logo-e-domizil-schweiz-60.png`,
      alt: 'e-domizil Schweiz',
    },

    {
      link: `//${cdn}/assets/portals/logo-bellevue-ferienhaus-60.png`,
      alt: 'Bellevue Ferienhaus',
    },

    {
      link: `//${cdn}/assets/portals/logo-premium-selection-by-e-domizil-60.png`,
      alt: 'Premium Selection by e-domizil',
    },
    {
      link: `//${cdn}/assets/portals/logo-tourist-online-60.png`,
      alt: 'tourist-online.de',
    },
    {
      link: `//${cdn}/assets/portals/logo-atraveo-60.png`,
      alt: 'atraveo',
    },
  ],
  [
    {
      link: `//${cdn}/assets/portals/logo-bestfewo-60.png`,
      alt: 'BestFewo.de',
    },
    {
      link: `//${cdn}/assets/portals/logo-cabaneo-60.png`,
      alt: 'cabaneo',
    },
    {
      link: `//${cdn}/assets/portals/logo-casamundo-60.png`,
      alt: 'casamundo',
    },
    {
      link: `//${cdn}/assets/portals/logo-holidaycheck-60.png`,
      alt: 'HolidayCheck',
    },
    {
      link: `//${cdn}/assets/portals/logo-holidu-60.png`,
      alt: 'holidu',
    },
    {
      link: `//${cdn}/assets/portals/logo-hometogo-60.png`,
      alt: 'hometogo',
    },
    {
      link: `//${cdn}/assets/portals/logo-hrs-holidays-60.png`,
      alt: 'HRS-Holidays',
    },
    {
      link: `//${cdn}/assets/portals/logo-kuoni-60.png`,
      alt: 'Kuoni',
    },
    {
      link: `//${cdn}/assets/portals/logo-lastminute-ch-60.png`,
      alt: 'lastminute.ch',
    },
    {
      link: `//${cdn}/assets/portals/logo-sbb-60.png`,
      alt: 'SBB CFF FFS',
    },
    {
      link: `//${cdn}/assets/portals/logo-sonnenklar-tv-60.png`,
      alt: 'sonnenklar.tv',
    },
    {
      link: `//${cdn}/assets/portals/logo-tchibo-60.png`,
      alt: 'Tchibo',
    },
  ],
];
const logosWithoutSystem = [
  [
    {
      link: '/img/logosWithoutSystem/logo-ats-60.png',
      alt: 'Logo Agro Tourismus schweiz',
    },
    {
      link: '/img/logosWithoutSystem/logo-engadin-60.png',
      alt: 'Logo engadin',
    },
    {
      link: '/img/logosWithoutSystem/logo-ferien-im-baudenkmal-60.png',
      alt: 'Logo Ferien im Baudenkmal',
    },
    {
      link: '/img/logosWithoutSystem/logo-jungfrau-region-60.png',
      alt: 'Logo Jungfrau Region',
    },
    {
      link: '/img/logosWithoutSystem/logo-ascona-locarno-60.png',
      alt: 'Logo Ascona Locarno',
    }],
  [

    {
      link: '/img/logosWithoutSystem/logo-luzern-60.png',
      alt: 'Logo Luzern',
    },
    {
      link: '/img/logosWithoutSystem/logo-residenza-viramonte-60.png',
      alt: 'Logo Residenza Viramonte',
    }, {
      link: '/img/logosWithoutSystem/logo-toggenburg-60.png',
      alt: 'Logo Toggenburg',
    },

  ],
];
const logosWithSystem = [
  [
    {
      link: '/img/logosWithSystem/logo-graubuenden-60.png',
      alt: 'Logo graubuenden',
    }, {
      link: '/img/logosWithSystem/logo-arosa-lenzerheide-60.png',
      alt: 'Logo Arosa Lenzerheide',
    }, {
      link: '/img/logosWithSystem/logo-davos-klosters-60.png',
      alt: 'Logo Davos Klosters',
    }, {
      link: '/img/logosWithSystem/logo-gstaad-60.png',
      alt: 'Logo Gstaad',
    }, {
      link: '/img/logosWithSystem/logo-adelboden-lenk-kandersteg-60.png',
      alt: 'Logo Adelboden Lenk Kandersteg',
    },
  ],
  [
    {
      link: '/img/logosWithSystem/logo-saas-fee-60.png',
      alt: 'Logo Saas Fee',
    }, {
      link: '/img/logosWithSystem/logo-jura-trois-lacs-drei-seen-land-60.png',
      alt: 'Logo Jura Trois-Lacs-Drei-Seen-Land-60',
    }, {
      link: '/img/logosWithSystem/logo-pays-d-enhaut-60.png',
      alt: 'Logo Pays D\'Enhaut',
    },
  ],
];

export { logosCH, logosWithoutSystem, logosWithSystem };
